import type {
  PersonInvolvement,
  PersonInvolvementKind,
} from "../types/involvement.js";
import { liveDesignatedAssessorInvolvement } from "./liveDesignatedAssessorInvolvement.js";

/**
 * Whether an involvement of this kind may not be started yet, given the
 * person's involvements at `now`: an approver approves the designated
 * assessor's work, so an approver involvement is started only once somebody is
 * designated.
 */
export const isInvolvementStartAwaitingDesignatedAssessor = (
  kind: PersonInvolvementKind,
  involvements: readonly Pick<
    PersonInvolvement,
    "kind" | "endedAt" | "expiresAt"
  >[],
  now: Date = new Date(),
): boolean =>
  kind === "approver" &&
  liveDesignatedAssessorInvolvement(involvements, now) === undefined;
